var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(require(("@/assets/vector/" + _vm.icon + ".svg")),_vm._g(_vm._b({ref:"comp",tag:"component",staticClass:"svg-icon",class:( _obj = {}, _obj[("svg-fill-" + _vm.color)] = _vm.color, _obj[("hover-icon-" + _vm.hover)] = _vm.hover, _obj )},'component',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }